import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Modal,
  ModalContent,
  ModalFooter
} from '@deque/cauldron-react';
import styles from './NoScreenshot.css';
import imageMissing from '../../assets/images/image-missing.svg';

interface NoScreenshotProps {
  explanation: React.ReactNode;
}

const NoScreenshot: React.FC<NoScreenshotProps> = ({ explanation }) => {
  const { t } = useTranslation();
  const [showExplanation, setShowExplanation] = useState(false);

  const toggleExplanation = () => {
    setShowExplanation(!showExplanation);
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.noScreenshotThumbnail}>
        <img
          src={imageMissing}
          // Image is decorative because there is a text equivalent
          alt=""
        />
        <div>{t('No screenshot available')}</div>
      </div>
      <Button variant="link" onClick={toggleExplanation}>
        {t('Why is there no screenshot?')}
      </Button>
      <Modal
        variant="info"
        heading={t('Why is there no screenshot?')}
        show={showExplanation}
        onClose={toggleExplanation}
      >
        <ModalContent>{explanation}</ModalContent>
        <ModalFooter>
          <Button onClick={toggleExplanation}>{t('Ok')}</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default NoScreenshot;
